export default __webpack_public_path__ + "static/media/best-doctor-icon.8b98eabc.svg";